export default __webpack_public_path__ + "fbd99861b866e09eac14fe731c7c8b1a.png";